import { Stack, styled } from "@mui/material";

export const RewardsContainer = styled(Stack)``;
